import axios from "axios";
import { URL } from "../services/http.service";

// Create axios instance with customer auth token
const getAuthHeaders = () => {
  const token = localStorage.getItem("customerAuthToken");
  return token ? { "x-customer-auth-token": token } : {};
};

// Register customer
export const registerCustomerService = async (resellerUuid, customerData) => {
  return await axios.post(
    `${URL}/reseller-customer/store/${resellerUuid}/register`,
    customerData,
  );
};

// Login customer
export const loginCustomerService = async (
  resellerUuid,
  email,
  password,
  fingerprint,
) => {
  return await axios.post(
    `${URL}/reseller-customer/store/${resellerUuid}/login`,
    { email, password, fingerprint },
  );
};

// Quick login with mobile (name + phone)
export const quickLoginService = async (
  resellerUuid,
  name,
  phone,
  fingerprint,
) => {
  return await axios.post(
    `${URL}/reseller-customer/store/${resellerUuid}/quick-login`,
    { name, phone, fingerprint },
  );
};

// Get customer profile
export const getCustomerProfileService = async () => {
  return await axios.get(`${URL}/reseller-customer/profile`, {
    headers: getAuthHeaders(),
  });
};

// Update customer profile
export const updateCustomerProfileService = async (profileData) => {
  return await axios.put(`${URL}/reseller-customer/profile`, profileData, {
    headers: getAuthHeaders(),
  });
};

// Get customer addresses
export const getCustomerAddressesService = async () => {
  return await axios.get(`${URL}/reseller-customer/profile`, {
    headers: getAuthHeaders(),
  });
};

// Add customer address
export const addCustomerAddressService = async (addressData) => {
  return await axios.post(`${URL}/reseller-customer/addresses`, addressData, {
    headers: getAuthHeaders(),
  });
};

// Update customer address
export const updateCustomerAddressService = async (addressId, addressData) => {
  return await axios.put(
    `${URL}/reseller-customer/addresses/${addressId}`,
    addressData,
    {
      headers: getAuthHeaders(),
    },
  );
};

// Delete customer address
export const deleteCustomerAddressService = async (addressId) => {
  return await axios.delete(`${URL}/reseller-customer/addresses/${addressId}`, {
    headers: getAuthHeaders(),
  });
};

// Set default address
export const setDefaultAddressService = async (addressId) => {
  return await axios.put(
    `${URL}/reseller-customer/addresses/${addressId}/default`,
    {},
    {
      headers: getAuthHeaders(),
    },
  );
};

// Send WhatsApp OTP
export const sendWhatsAppOtpService = async (phone, userName) => {
  try {
    const response = await axios.post(`${URL}/risk-otp/whatsapp-send`, {
      phone,
      userName,
    });
    return response;
  } catch (error) {
    console.error("Error in sendWhatsAppOtpService:", error);
    throw error;
  }
};

export const whatsappLoginService = async (resellerUuid, loginData) => {
  return await axios.post(
    `${URL}/reseller-customer/store/${resellerUuid}/whatsapp-login`,
    loginData,
  );
};

export const generateStorePasskeyRegistrationOptions = async () => {
  return axios.post(
    `${URL}/reseller-customer/profile/passkey/registration-options`,
    {},
    { headers: getAuthHeaders() },
  );
};

export const verifyStorePasskeyRegistration = async (payload) => {
  return axios.post(
    `${URL}/reseller-customer/profile/passkey/verify-registration`,
    payload,
    { headers: getAuthHeaders() },
  );
};

export const generateStorePasskeyAuthenticationOptions = async (resellerUuid) => {
  return axios.post(
    `${URL}/reseller-customer/store/${resellerUuid}/passkey/authentication-options`,
    {},
  );
};

export const verifyStorePasskeyAuthentication = async (payload) => {
  return axios.post(
    `${URL}/reseller-customer/store/${payload.resellerUuid}/passkey/verify-authentication`,
    payload,
  );
};
